(function (global) {
  'use strict';
  function normalized(value) { return String(value || '').trim().toLowerCase().replace(/[\s_-]+/g, ' '); }
  function packSize(value) {
    var v = normalized(value);
    if (/^(3|three|3 pack|3 packs|pack of 3|three pack)$/.test(v)) return 3;
    if (/^(6|six|6 pack|6 packs|pack of 6|six pack)$/.test(v)) return 6;
    return 0;
  }
  function catalogColors(product) {
    var colors = new Map([['midnight', 'Midnight'], ['combo', 'Combo']]);
    ((product && product.variants) || []).forEach(function (v) {
      var options = (v.options || String(v.title || '').split('/'));
      var rest = options.filter(function (s) { return !['nylon', 'metal'].includes(normalized(s)) && !packSize(s); });
      if (rest.length === 1) colors.set(normalized(rest[0]), String(rest[0]).trim());
    });
    return Array.from(colors, function (entry) { return { value: entry[0], label: entry[1] }; });
  }
  function combinedMappings(product, images) {
    var mappings = {}, variants = product && Array.isArray(product.variants) ? product.variants : [];
    var colors = catalogColors(product);
    var hasSizes = variants.some(function (v) { return (v.options || String(v.title || '').split('/')).some(packSize); });
    ['nylon', 'metal'].forEach(function (material) {
      colors.forEach(function (choice) {
        var color = choice.value;
        [3, 6].forEach(function (size) {
        var matches = variants.filter(function (variant) {
          var options = (variant.options || String(variant.title || '').split('/')).map(normalized);
          var rest = options.filter(function (value) { return value !== material && value !== color; });
          return options.includes(material) && options.includes(color) &&
            (hasSizes ? rest.length === 1 && packSize(rest[0]) === size : rest.length === 0);
        });
        mappings[material + '_' + color + (size === 6 ? '_6' : '')] = {
          key: matches.length === 1 ? String(matches[0].id) : '',
          variants: matches,
          image: images && images[material] || '',
          units: size === 6 && !hasSizes ? 2 : 1,
          packSize: hasSizes ? size : 3,
          color: choice.label,
          error: !variants.length ? 'Select your Anchors product in this block.' :
            matches.length > 1 ? 'More than one matching ' + size + '-pack. Check this product’s variant options.' :
            'No matching ' + material + ' / ' + color + ' ' + size + '-pack. Check the product’s Material, Color and Size options.'
        };
        });
      });
    });
    colors.forEach(function (choice) {
      var match = mappings['metal_' + choice.value];
      mappings['gift_' + choice.value] = match.variants.length ? match : mappings.metal_midnight;
    });
    return mappings;
  }
  function selection(config, material, color, count) {
    return config.mappings[material + '_' + color + (config.combined && Number(count) === 2 ? '_6' : '')];
  }
  function prepare(config) {
    if (!config.combined) return config;
    return Object.assign({}, config, {
      mappings: combinedMappings(config.product, config.images),
      colors: catalogColors(config.product),
      giftQuantity: config.product && Array.isArray(config.product.variants) && config.product.variants.length ? config.giftQuantity : 0
    });
  }
  function resolve(mapping) {
    if (!mapping || !String(mapping.key || '').trim()) return { error: mapping && mapping.error || 'Configure an exact anchor variant.' };
    var key = String(mapping.key).trim().toLowerCase();
    var matches = (mapping.variants || []).filter(function (v) { return String(v.id) === key || String(v.title).trim().toLowerCase() === key; });
    if (matches.length !== 1) return { error: 'Missing or ambiguous anchor variant mapping.' };
    if (!matches[0].available) return { error: 'This anchor variant is sold out.' };
    return { variant: matches[0] };
  }
  function price(cents, percent) { return Math.round(Number(cents) * (100 - Number(percent)) / 100); }
  function displayPercent(config, bundle, actualPercent) {
    if (!config.automatic) return actualPercent;
    var defaults = { single: 30, buddy: 50, squad: 50 };
    var value = config.displayOffers && config.displayOffers[bundle];
    value = Number(value == null ? defaults[bundle] : value);
    return Number.isFinite(value) && value >= 0 && value <= 100 ? value : 0;
  }
  function plan(config, state, bundle) {
    var offer = config.offers[bundle];
    var result = { lines: [], codes: [], total: 0, error: '', percent: offer ? Number(offer.percent) : 0, included: bundle === 'squad' ? Number(config.giftQuantity) : 0 };
    result.automatic = !!config.automatic;
    if (config.automatic) result.percent = 0;
    if (!offer) { result.error = 'Configure this package’s anchor offer.'; return result; }
    var count = Number(state.quantity);
    if (!Number.isInteger(count) || count < 0 || count > 99) { result.error = 'Choose 0–99 paid packs.'; return result; }
    if (config.combined && count > 2) { result.error = 'Choose 3 Pack or 6 Pack.'; return result; }
    if (!(result.percent >= 0 && result.percent <= 100)) { result.error = 'Invalid anchor discount percentage.'; return result; }
    function add(mapping, quantity, role, percent, code) {
      if (!quantity) return;
      var resolved = resolve(mapping);
      if (resolved.error) { result.error = resolved.error; return; }
      if (!config.automatic && (!config.confirmed || (percent > 0 && !String(code || '').trim()))) {
        result.error = 'Anchor offer unavailable: merchant must configure and verify Shopify discounts.'; return;
      }
      var v = resolved.variant;
      var unit = price(v.price, percent);
      result.lines.push({ id: v.id, quantity: quantity, role: role, unit: unit, original: Number(v.price), code: String(code || '').trim(),
        packSize: mapping.packSize || 3, color: mapping.color || (role === 'gift' ? giftColor : paidColor),
        image: mapping.image || (v.featured_image && (v.featured_image.src || v.featured_image)) || '' });
      result.total += unit * quantity;
      if (code) result.codes.push(String(code).trim());
    }
    var paidColor = state.colors ? state.colors[state.material] : state.color;
    var giftColor = state.colors ? state.colors.metal : state.color;
    var mapping = selection(config, state.material, paidColor, count);
    add(mapping, count && config.combined ? (mapping && mapping.units || 1) : count, 'paid', result.percent, offer.code);
    if (result.included) add(config.mappings['gift_' + giftColor], result.included, 'gift', 100, config.giftCode);
    return result;
  }
  function verify(cart, section, group, expected, hasCode) {
    var lines = (cart.items || []).filter(function (line) {
      var p = line.properties || {};
      return p._clp_section === section && p._clp_anchor === group;
    });
    // Shopify can split one requested variant/quantity into multiple discounted lines.
    // Validate the complete allocation, not the number of response rows.
    if (lines.some(function (line) {
      return !expected.lines.some(function (want) { return want.role === (line.properties || {})._clp_anchor_role; });
    })) return false;
    return expected.lines.every(function (want) {
      var matches = lines.filter(function (line) { return (line.properties || {})._clp_anchor_role === want.role; });
      if (!matches.length || matches.some(function (line) {
        return String(line.variant_id) !== String(want.id) ||
          !Number.isInteger(Number(line.quantity)) || Number(line.quantity) <= 0 ||
          line.final_line_price == null || line.final_line_price === '' ||
          !Number.isFinite(Number(line.final_line_price)) || Number(line.final_line_price) < 0;
      })) return false;
      var line = matches.reduce(function (sum, part) {
        sum.quantity += Number(part.quantity);
        sum.original_line_price += Number(part.original_line_price);
        sum.final_line_price += Number(part.final_line_price);
        sum.line_level_discount_allocations = sum.line_level_discount_allocations.concat(part.line_level_discount_allocations || []);
        return sum;
      }, { variant_id: want.id, quantity: 0, original_line_price: 0, final_line_price: 0, line_level_discount_allocations: [] });
      if (expected.automatic) return String(line.variant_id) === String(want.id) && Number(line.quantity) === want.quantity &&
        Number.isFinite(Number(line.final_line_price)) && Number(line.final_line_price) >= 0 &&
        (want.role === 'gift' ? Number(line.final_line_price) === 0 : Number(line.final_line_price) <= want.original * want.quantity);
      var allocations = line.line_level_discount_allocations || [];
      var applied = allocations.reduce(function (sum, a) { return sum + Number(a.amount || 0); }, 0);
      return String(line.variant_id) === String(want.id) && Number(line.quantity) === want.quantity &&
        Number(line.original_line_price) === want.original * want.quantity &&
        Number(line.final_line_price) === want.unit * want.quantity &&
        applied === (want.original - want.unit) * want.quantity &&
        (!want.code || (hasCode(cart, want.code) && allocations.some(function (a) {
          var app = a.discount_application || {};
          return app.type === 'discount_code' && String(app.title).toLowerCase() === want.code.toLowerCase() && Number(a.amount) > 0;
        })));
    });
  }
  function mount(node, refresh, money) {
    var config = prepare(JSON.parse(node.querySelector('[data-anchor-config]').textContent));
    var material = node.querySelector('[data-anchor-material]');
    var color = node.querySelector('[data-anchor-color]');
    var quantity = node.querySelector('[data-anchor-quantity]');
    var opt = node.querySelector('[data-anchor-opt]');
    var status = node.querySelector('[data-anchor-status]');
    var included = node.querySelector('[data-anchor-included]');
    var paid = node.querySelector('[data-anchor-paid]');
    var last = null;
    var cards = Array.from(node.querySelectorAll('[data-anchor-card]'));
    var sizes = { nylon: 1, metal: 1 };
    var colors = config.colors || [{ value: 'midnight', label: 'Midnight' }, { value: 'combo', label: 'Combo' }];
    if (config.combined) {
      var currentColor = color.value;
      color.replaceChildren();
      colors.forEach(function (shade) {
        var option = global.document.createElement('option'); option.value = shade.value; option.textContent = shade.label; color.appendChild(option);
      });
      color.value = currentColor || 'midnight';
    }
    var materialColors = { nylon: color.value || 'midnight', metal: color.value || 'midnight' };
    var listeners = [];
    var registry = global.ClutchLoopUnitDropdown ? global.ClutchLoopUnitDropdown.createRegistry() : null;
    function listen(el, type, fn) { if (el) { el.addEventListener(type, fn); listeners.push(function () { el.removeEventListener(type, fn); }); } }
    // Quantity owns variant-pill sizing. Anchor blocks are siblings, so they cannot
    // inherit its settings directly; mirror the rendered package pill, not its colors.
    function syncPackagePills() {
      var section = node.closest('[data-cl-builder]');
      var source = section && (section.querySelector('.clp-package.is-selected .clp-unit') || section.querySelector('.clp-packages .clp-unit'));
      if (!source) return;
      var style = global.getComputedStyle(source);
      var swatch = source.querySelector('.clp-package__swatch');
      var swatchStyle = swatch && global.getComputedStyle(swatch);
      node.querySelectorAll('.clp-anchors__color .clp-unit__button').forEach(function (button) {
        ['fontFamily', 'fontSize', 'fontWeight', 'fontStyle', 'lineHeight', 'letterSpacing',
          'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'gap', 'borderRadius'].forEach(function (property) {
          button.style[property] = style[property];
        });
        var image = button.querySelector('.clp-unit__swatch');
        if (image && swatchStyle) { image.style.width = swatchStyle.width; image.style.height = swatchStyle.height; }
      });
    }
    listen(global, 'resize', syncPackagePills);
    function imageFor(type, shade, size) {
      var mapping = selection(config, type, shade, size || sizes[type]) || {};
      var v = mapping.variants && mapping.variants.length === 1 ? mapping.variants[0] : null;
      return mapping.image || (v && v.featured_image && (v.featured_image.src || v.featured_image)) || '';
    }
    function includedGift(type) {
      return type === 'metal' && last && !last.error && last.lines.find(function (line) { return line.role === 'gift'; });
    }
    function choose(type, count) { material.value = type; color.value = materialColors[type]; quantity.value = String(count); if (count) sizes.nylon = sizes.metal = count; refresh(); }
    node.querySelectorAll('[data-anchor-size]').forEach(function (button) {
      listen(button, 'click', function () {
        sizes.nylon = sizes.metal = Number(button.dataset.anchorSize);
        if (Number(quantity.value) > 0) quantity.value = String(sizes.nylon);
        refresh();
      });
    });
    cards.forEach(function (card) {
      var type = card.dataset.anchorCard;
      function toggleCard() { if (!includedGift(type)) choose(type, material.value === type && Number(quantity.value) > 0 ? 0 : sizes[type]); }
      var includedNote = global.document.createElement('div');
      includedNote.className = 'clp-anchor-included';
      includedNote.hidden = true;
      var extraButton = global.document.createElement('button');
      extraButton.type = 'button';
      includedNote.appendChild(extraButton);
      var actionRow = node.querySelector('[data-anchor-actions]');
      if (actionRow) actionRow.appendChild(includedNote);
      else card.insertAdjacentElement('afterend', includedNote);
      listeners.push(function () { includedNote.remove(); });
      card._includedNote = includedNote;
      card._extraButton = extraButton;
      listen(extraButton, 'click', function (event) {
        event.stopPropagation();
        choose(type, material.value === type && Number(quantity.value) > 0 ? 0 : sizes[type]);
      });
      listen(card, 'click', function (event) { if (!event.target.closest('button,select,a')) toggleCard(); });
      listen(card.querySelector('[data-anchor-toggle]'), 'click', toggleCard);
      var host = card.querySelector('[data-anchor-color-pill]');
      if (host && registry) {
        var dropdown = global.ClutchLoopUnitDropdown.attach({
          registry: registry,
          label: function () { return type + ' anchor color'; },
          getValue: function () { return materialColors[type]; },
          getOptions: function () {
            return colors.filter(function (entry) {
              var mapping = selection(config, type, entry.value, sizes[type]);
              return !config.combined || mapping && mapping.variants.length;
            }).map(function (entry) {
              var shade = entry.value;
              return { value: shade, label: entry.label, available: !!resolve(selection(config, type, shade, sizes[type])).variant,
                swatch: function () { var src = imageFor(type, shade); var img = global.document.createElement(src ? 'img' : 'span'); if (src) { img.src = src; img.alt = ''; } return img; } };
            });
          },
          onChoose: function (shade) {
            materialColors[type] = shade;
            if (material.value === type) color.value = shade;
            if (includedGift(type)) refresh();
            else choose(type, material.value === type && Number(quantity.value) ? Number(quantity.value) : sizes[type]);
          }
        });
        host.appendChild(dropdown.button);
        card._anchorDropdown = dropdown;
      }
    });
    function change(event) {
      if (event.target === color) materialColors[material.value] = color.value;
      else if (event.target === material) color.value = materialColors[material.value];
      refresh();
    }
    [material, color, quantity].forEach(function (el) { el.addEventListener('change', change); });
    function toggle() { quantity.value = opt.checked ? '1' : '0'; refresh(); }
    opt.addEventListener('change', toggle);
    return {
      group: config.id,
      codes: Object.values(config.offers).map(function (o) { return o.code; }).concat(config.giftCode).filter(Boolean),
      suggest: function (gap) {
        var count = Number(quantity.value), mapping = selection(config, material.value, color.value, count + 1);
        var v = resolve(mapping).variant;
        if (!last || last.error || !config.confirmed || !v || count >= 2 || gap > 600 || gap <= 0) return null;
        var existing = last.lines.filter(function (line) { return line.role === 'paid'; }).reduce(function (sum, line) { return sum + line.unit * line.quantity; }, 0);
        var unit = config.combined ? price(v.price, last.percent) * mapping.units - existing : price(v.price, last.percent);
        if (unit < gap) return null;
        return { price: unit, label: count ? 'Upgrade anchors to 6 Pack' : 'Anchors (3)', add: function () { choose(material.value, count + 1); } };
      },
      products: function () {
        if (!last || last.error) return [];
        return last.lines.map(function (line) {
          var type = line.role === 'gift' ? 'metal' : material.value;
          return { label: (line.quantity * line.packSize) + ' ' + (type === 'metal' ? 'Metal' : 'Nylon') + ' Anchors' + (line.role === 'gift' ? ' · Free gift' : ''),
            gift: line.role === 'gift', cents: line.unit * line.quantity, swatches: Array.from({ length: line.quantity }, function () {
              var displayColor = colors.find(function (entry) { return String(entry.value).toLowerCase() === String(line.color).toLowerCase(); });
              return { image: line.image, name: displayColor ? displayColor.label : line.color };
            }) };
        });
      },
      update: function (card) {
        var title = card ? card.dataset.clPackageTitle : '';
        var keys = Object.keys(config.offers).filter(function (key) { return config.offers[key].title === title; });
        if (config.combined) {
          var units = Number(card && card.dataset.clUnitCount);
          keys = [units >= 4 ? 'squad' : units >= 2 ? 'buddy' : 'single'];
        }
        last = plan(config, { material: material.value, color: color.value, colors: materialColors, quantity: quantity.value }, keys.length === 1 ? keys[0] : '');
        opt.checked = Number(quantity.value) > 0;
        var chosen = resolve(selection(config, material.value, color.value, Number(quantity.value)));
        var setup = !config.automatic && (!config.confirmed || (last.percent > 0 && (!keys.length || !config.offers[keys[0]].code)));
        var discount = node.querySelector('[data-anchor-discount]');
        var shownPercent = displayPercent(config, keys.length === 1 ? keys[0] : '', last.percent);
        if (discount) {
          discount.hidden = shownPercent === 0 || keys.length !== 1 || Boolean(last.error) || setup;
          discount.textContent = shownPercent + '% OFF';
          discount.title = 'Displayed offer. Matching automatic discount must be configured in Shopify; final price confirmed in cart.';
        }
        status.textContent = last.error || (Number(quantity.value) ? chosen.error : '') || (setup ? 'Anchor offer unavailable until Shopify discount setup is verified.' : '');
        status.hidden = !status.textContent;
        included.hidden = !last.included || !!includedGift('metal') && cards.some(function (card) { return card.dataset.anchorCard === 'metal'; });
        var giftMapping = config.mappings['gift_' + materialColors.metal];
        included.textContent = last.included ? last.included + ' included metal 3-pack(s) · ' + (giftMapping && giftMapping.color || materialColors.metal) + ' · ' + (last.error ? 'Unavailable — not added as a paid gift' : 'Free with Squad, subject to cart confirmation') : '';
        paid.textContent = Number(quantity.value) + ' paid pack(s) · ' + (Number(quantity.value) * 3) + ' extra anchors · ' + (last.error ? 'Unavailable' : money(last.total));
        if (!cards.length) node.querySelectorAll('[data-anchor-image]').forEach(function (img) { img.hidden = img.dataset.anchorImage !== material.value; });
        if (Number(quantity.value) > 0) sizes.nylon = sizes.metal = Number(quantity.value);
        node.querySelectorAll('[data-anchor-size]').forEach(function (button) {
          button.setAttribute('aria-pressed', String(Number(button.dataset.anchorSize) === sizes.nylon));
        });
        cards.forEach(function (card) {
          var type = card.dataset.anchorCard;
          var selected = material.value === type && Number(quantity.value) > 0;
          var gift = includedGift(type);
          var size = selected ? Number(quantity.value) : sizes[type];
          var titleCount = card.querySelector('[data-anchor-title-count]');
          if (titleCount) titleCount.textContent = String(gift ? gift.quantity * gift.packSize : size * 3);
          var shade = materialColors[type];
          var mapping = selection(config, type, shade, size);
          var v = resolve(mapping).variant;
          var units = config.combined ? mapping && mapping.units || 1 : size;
          var photo = card.querySelector('[data-anchor-image]');
          if (photo) {
            var photoSrc = gift ? gift.image : imageFor(type, shade);
            photo.hidden = !photoSrc;
            if (photoSrc) photo.src = photoSrc;
            else photo.removeAttribute('src');
            if (photo.parentElement) photo.parentElement.classList.toggle('is-blank', !photoSrc);
          }
          card.classList.toggle('is-selected', selected || !!gift);
          var toggle = card.querySelector('[data-anchor-toggle]');
          if (toggle) toggle.setAttribute('aria-pressed', String(selected || !!gift));
          card.querySelectorAll('[data-anchor-size]').forEach(function (button) { button.setAttribute('aria-pressed', String(Number(button.dataset.anchorSize) === size)); });
          var priceNode = card.querySelector('[data-anchor-card-price]'), compare = card.querySelector('[data-anchor-card-compare]');
          if (priceNode) {
            priceNode.textContent = gift ? money(0) : v ? '+' + money(price(v.price, shownPercent) * units) : 'Unavailable';
            priceNode.title = gift ? 'Included with Squad; free price verified in Shopify cart.' : shownPercent ? 'Includes ' + shownPercent + '% displayed discount; final price confirmed in cart.' : '';
          }
          if (compare) {
            var savings = gift ? gift.original * gift.quantity : v ? (v.price - price(v.price, shownPercent)) * units : 0;
            compare.textContent = gift || v ? 'Saving ' + money(Math.max(0, savings)) : '';
            compare.hidden = !gift && !v;
          }
          card._includedNote.hidden = !gift;
          if (gift) {
            card._extraButton.textContent = selected
              ? 'Remove extra ' + (size * 3) + ' anchors (+' + money(price(v ? v.price : 0, shownPercent) * units) + ')'
              : 'Add extra ' + (size * 3) + ' anchors' + (v ? ' · +' + money(price(v.price, shownPercent) * units) : ' · Unavailable');
            card._extraButton.disabled = !selected && !v;
          }
          if (card._anchorDropdown) {
            var dropdown = card._anchorDropdown, src = imageFor(type, shade);
            dropdown.button.replaceChildren();
            if (src) { var sw = global.document.createElement('img'); sw.src = src; sw.alt = ''; sw.className = 'clp-unit__swatch'; dropdown.button.appendChild(sw); }
            var label = global.document.createElement('span'); label.textContent = (colors.find(function (entry) { return entry.value === shade; }) || {}).label || shade; dropdown.button.appendChild(label);
            var arrow = global.document.createElement('span'); arrow.textContent = '⌄'; arrow.setAttribute('aria-hidden', 'true'); dropdown.button.appendChild(arrow);
            dropdown.update(); dropdown.refresh();
          }
        });
        syncPackagePills();
        return last;
      },
      current: function () { return last; },
      cleanup: function () { [material, color, quantity].forEach(function (el) { el.removeEventListener('change', change); }); opt.removeEventListener('change', toggle); listeners.forEach(function (fn) { fn(); }); if (registry) registry.destroy(); }
    };
  }
  var api = { resolve: resolve, price: price, displayPercent: displayPercent, plan: plan, verify: verify, mount: mount, combinedMappings: combinedMappings, prepare: prepare };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  global.ClutchLoopAnchors = api;
})(typeof window !== 'undefined' ? window : globalThis);
